import { render } from "./LocationStatuses.vue?vue&type=template&id=1c51a777&scoped=true"
import script from "./LocationStatuses.vue?vue&type=script&lang=js"
export * from "./LocationStatuses.vue?vue&type=script&lang=js"

import "../assets/css/viver-style.css?vue&type=style&index=0&id=1c51a777&scoped=true&lang=css&external"
import "./LocationStatuses.vue?vue&type=style&index=1&id=1c51a777&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c51a777"]])

export default __exports__